import jQuery from 'jquery';
const $ = jQuery;

window.jQuery = $;
window.$ = $;

import 'cssuseragent';
import 'jquery.easing';
import 'jquery-mousewheel';

import 'malihu-custom-scrollbar-plugin';

import Ticker from './modules/Ticker';
import Hero from './modules/Hero';
import BackgroundImg from './modules/BackgroundImg';
import BlogList from './modules/BlogList';
import ProfileModal from './modules/ProfileModal';
import GalleryModal from './modules/GalleryModal';

const setVw = () => {
  const vw = document.documentElement.clientWidth; // / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
};
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

class MainApp {
  constructor() {
    console.log('MainApp');
    if (this.isTouchDevice()) {
      $('html').addClass('is-touch-device');
      $('a').attr('data-touch', 'true');
      $('button').attr('data-touch', 'true');
    } else {
      $('html').addClass('is-mouse-device');
    }

    this.$window = $(window);
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();

    this.scrollableElement = null;
    let firefox = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
    if ('scrollingElement' in document) {
      this.scrollableElement = document.scrollingElement;
    } else if (
      /*@cc_on!@*/ false ||
      (!!window.MSInputMethodContext && !!document.documentMode)
    ) {
      this.scrollableElement = document.documentElement;
    } else if (firefox && parseInt(firefox[1]) <= 47) {
      this.scrollableElement = document.documentElement;
    } else {
      this.scrollableElement = document.body;
    }

    // メニューの開閉
    $('.header_menu_bar').on('click', () => {
      $('.header_menu').toggleClass('active');

      if ($('.header_menu').hasClass('active')) {
        $('.header_menu_button_title').text('CLOSE');
      } else {
        $('.header_menu_button_title').text('MENU');
      }
    });

    $('.qa_list--item_category').click((e) => {
      if ($(e.currentTarget).parent('.qa_list--item').hasClass('active')) {
        $(e.currentTarget).parent('.qa_list--item').removeClass('active');
        $(e.currentTarget).next('.qa_list--item_post').slideUp();
      } else {
        $(e.currentTarget).parent('.qa_list--item').addClass('active');
        $(e.currentTarget).next('.qa_list--item_post').slideDown();
      }
    });

    // form select 変更
    $('.sec_contact_form--select_area select').on('change', (e) => {
      let $this = $(e.target);
      let $option = $this.find('option:selected');
      let $formWrap = $this.parent().parent().parent();
      let $label = $formWrap.find('.sec_contact_form--select_label');
      $label.children('p').text($option.text());

      $this.blur();
    });

    if ($('.sec_rc_wrap').length) {
      $('.sec_rc_wrap').each((i, e) => {
        new BackgroundImg($(e));
      });
    }

    if ($('body').hasClass('post-type-archive-qa')) {
      var urlHash = location.hash;
      if (urlHash) {
        $(urlHash + '.qa_list--item')
          .children('.qa_list--item_category')
          .trigger('click');

        $('body,html').stop().scrollTop(0);

        setTimeout(() => {
          var headerHeight = $('.ticker').outerHeight();
          var target = $(urlHash);
          var position = target.offset().top - headerHeight;
          $('body,html').stop().animate({ scrollTop: position }, 500);
        }, 100);
      }
    }

    new Ticker();

    if ($('.top_visual_slider').length) {
      new Hero();
    }

    if ($('.ProfileModal').length) {
      new ProfileModal();
    }
    if ($('.GalleryModal').length) {
      new GalleryModal();
    }

    // sec_blog_list
    if ($('.sec_blog_list').length) {
      $('.sec_blog_list').each((i, e) => {
        new BlogList($(e));
      });
    }

    if ($('.blog_detail_area').length) {
      $('.blog_detail_area')
        .find('iframe')
        .each((i, e) => {
          if ($(e).attr('src').indexOf('youtube') != -1) {
            $(e).wrap('<div class="Embed--youtube"></div>');
          }
        });
    }

    this.$window
      .on('resize', () => {
        this.onWindowResize();
      })
      .on('scroll', () => {
        this.onWindowScroll();
      });
    this.onWindowResize();
  }

  isTouchDevice() {
    return 'ontouchstart' in window || navigator.msPointerEnabled
      ? true
      : false;
  }

  scrollPage(val, isCancelTransition = false) {
    if (this.viewMode) val -= 50;
    if (isCancelTransition) {
      $(this.scrollableElement).stop(false).scrollTop(val);
    } else {
      $(this.scrollableElement)
        .stop(false)
        .animate({ scrollTop: val }, 300, 'easeOutExpo');
    }
  }

  onWindowScroll() {
    this.scrollTop = this.$window.scrollTop();
    if (this.scrollTop < 0) this.scrollTop = 0;

    /*
    if(this.pageApp != undefined) {
      this.pageApp.onWindowScroll(this.scrollTop);
    }
	*/
  }

  onWindowResize() {
    clearInterval(this.resizeCompleteInterval);
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();

    this.onWindowScroll();
    this.resizeCompleteInterval = setInterval(() => {
      clearInterval(this.resizeCompleteInterval);

      /*
      if ($(".sec_blog_list").length) {
        $(".sec_blog_list").each((i, e) => {
          $(e).mCustomScrollbar("update");
          console.log($(e));
        });
      }
	  */
    }, 1000);
  }

  onLoad() {
    this.onWindowResize();
  }
}

let mainApp = undefined; //new MainApp();

$('document').ready(() => {
  mainApp = new MainApp();
  $(document).on('touchstart', 'a, button', (e) => {
    $(e.currentTarget).attr('data-touch', 'true');
  });
  $(document).on('mouseleave', 'a, button', (e) => {
    $(e.currentTarget).removeAttr('data-touch');
  });
});

$(window).on('load', () => {
  mainApp.onLoad();
});
